var _circle, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 38",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3978,
    cy: 25.8592,
    r: 8.34372,
    transform: "rotate(30 11.3978 25.8592)",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6655,
    y: 14.7808,
    width: 7.15176,
    height: 3.57588,
    transform: "rotate(30 13.6655 14.7808)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2163 9.41118C18.2163 9.41118 19.4495 12.8678 19.0064 14.1505C18.3616 16.0172 14.0002 17.3839 14.0002 17.3839",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8967 2.09127L18.5944 5.49582L22.8896 3.97636L20.2618 7.59995L22.9595 11.0045L18.6376 9.83944L16.0098 13.463L15.9666 9.1194L11.6447 7.95435L15.9399 6.43489L15.8967 2.09127Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.9c3a4a55.svg";
export { ForwardRef as ReactComponent };